import React from 'react';

export default function TheNumber() {
  const digits = '1,000,000,000';
  return (
    <section id="l7" className="chapter" style={{ flexDirection: 'column', justifyContent: 'center' }}>
      <div className="chapter-eyebrow font-sans" style={{ margin: '0 auto 30px', justifyContent: 'center' }}>
        <span style={{ height: 1, width: 60, background: 'linear-gradient(to left, #f3c04a, transparent)' }} />
        LIFE VII · THE NUMBER
      </div>

      <div className="number-display">
        {digits.split('').map((c, i) => (
          <span key={i} style={{ opacity: c === ',' ? 0.4 : 1, margin: c === ',' ? '0 6px' : '0 2px', display: 'inline-block' }}>{c}</span>
        ))}
      </div>
      <div className="number-caption font-sans">SCALES IN THE REEF · TOTAL SUPPLY</div>

      <div className="number-stats">
        <div className="stat">
          <div className="val">0% / 0%</div>
          <div className="lbl font-sans">BUY · SELL TAX</div>
        </div>
        <div className="stat">
          <div className="val">100%</div>
          <div className="lbl font-sans">LP BURNED</div>
        </div>
        <div className="stat">
          <div className="val">Revoked</div>
          <div className="lbl font-sans">MINT AUTHORITY</div>
        </div>
      </div>
    </section>
  );
}
